import BadgeNext from "ds/components/BadgeNext";
import Box from "ds/components/Box";
import LinkButton from "ds/components/Button/LinkButton";
import Counter from "ds/components/Counter";
import ActionCard from "ds/components/ActionCard";

import { IntegrationView } from "../../types";
import { isIntegrationNew } from "../../utils/isIntegrationNew";

type IntegrationCardProps = IntegrationView;

const IntegrationCard = ({
  id,
  name,
  description,
  icon,
  docsLink,
  hasViewScreen,
  newUntil,
  redirect,
  count,
}: IntegrationCardProps) => {
  const internalLink = hasViewScreen || !!redirect;
  const link = redirect ?? (hasViewScreen ? `./${id}` : docsLink);
  const target = internalLink ? undefined : "_blank";
  const linkText = internalLink ? "View" : "Go to docs";
  const showNewBadge = isIntegrationNew(newUntil);

  return (
    <ActionCard
      title={name}
      description={description}
      icon={icon}
      actionComponent={
        <LinkButton to={link} variant="secondary" target={target}>
          {linkText}
        </LinkButton>
      }
      titleSuffix={
        <Box gap="medium" align="center">
          {showNewBadge && <BadgeNext variant="blue" type="strong" text="New" />}
          {count ? <Counter count={count} /> : null}
        </Box>
      }
    />
  );
};

export default IntegrationCard;
